/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitacaoExclusaoFeedbackAliases {
  FIELD_PROTOCOLOS = 'field-protocolos',
  FORM_PROTOCOLOS = 'form-protocolos',
  LAYOUT_SOLICITACAO_EXCLUSAO_FEEDBACK = 'layout-solicitacao-exclusao-feedback',
  MAPPER_PROTOCOLO = 'mapper-protocolo',
  MAPPER_TESET = 'mapper-teset',
  PANEL_0 = 'panel-0',
  PANEL_DS_MENSAGEM_WEB = 'panel-ds_mensagem_web',
  PANEL_ORIENTACAO = 'panel-orientacao',
  PANEL_PROTOCOLOS = 'panel-protocolos',
  REPEATER_PROTOCOLOS = 'repeater-protocolos',
  TEXT_0 = 'text-0',
  TEXT_DS_MENSAGEM_WEB = 'text-ds_mensagem_web',
  TEXT_ORIENTACAO = 'text-orientacao',
  TEXT_PROTOCOLO = 'text-protocolo',
  TEXT_TESET = 'text-teset',
}
export { SolicitacaoExclusaoFeedbackAliases };
